import { render, staticRenderFns } from "./ElementPreview.vue?vue&type=template&id=4f5bbc5e&"
import script from "./ElementPreview.vue?vue&type=script&lang=js&"
export * from "./ElementPreview.vue?vue&type=script&lang=js&"
import style0 from "./ElementPreview.vue?vue&type=style&index=0&id=4f5bbc5e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports